import DataTableBody from "@eisinc/MobiusOverrides/DataTable/DataTableBody";

export default DataTableBody;

export * from "@eisinc/MobiusOverrides/DataTable/DataTableBody";
